export default /*@ngInject*/ function () {
    return function (scope, element, attrs, compile) {
        if (scope.$last) {
            angular.element('#side-menu').addClass("nav metismenu");
            angular.element('#side-menu').metisMenu();
        }
    };
}